<template>
  <div
    class="one_col_wrap"
    :class="extraClass"
    :style="{ paddingTop: $store ? $store.state.headerHeight+'px' : 82 + 'px', backgroundColor: backgroundColor }"
  >
    <div
      class="slide_image"
      :style="{ backgroundImage: 'url('+backgroundImage+')' }"
      :class="{ end: titleEnd }"
      v-if="header"
    >
      <div class="slide_title" :style="{maxWidth: maxWidth, padding: padding}">
        <slot name="title"></slot>
      </div>
    </div>
    <div
      class="one_col_inner"
      :class="{ shadow, center }"
      :style="{maxWidth: maxWidth, borderRadius: borderRadius + 'px', padding: padding}"
    >
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "OneCol",
  props: {
    maxWidth: {
      type: String,
      default: "750px" // in px
    },
    borderRadius: {
      type: Number,
      default: 20 // in px
    },
    backgroundImage: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: "#ffffff"
    },
    slideColor: {
      type: String,
      default: "#ffffff"
    },
    shadow: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: true
    },
    padding: {
      type: String
    },
    titleEnd: {
      type: Boolean,
      default: false
    },
    extraClass: {
      type: String
    }
  }
};
</script>

<style lang="scss">
.one_col_wrap {
  display: flex;
  width: 100%;
  min-height: 100vh;
  justify-content: center;
  align-content: flex-start;
  align-items: flex-start;
  background-size: cover;
  background-position: center;
  color: black;
  padding-bottom: 69px;
  flex-wrap: wrap;
  @media (max-width: 767px) {
    justify-content: flex-start;
    align-items: flex-start;
    // background-image: none !important;
  }

  .slide_image {
    width: 100%;
    min-height: 35vh;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
    @media (max-width: 767px) {
      min-height: 25vh;
    }
    &.end {
      padding: 0;
      @media (max-width: 767px) {
        align-items: flex-end;
      }
    }

    .slide_title {
      padding: 12px;
      width: 100%;
      height: 100%;
      min-height: calc(35vh - 24px);
      display: flex;
      @media (max-width: 767px) {
        min-height: calc(25vh - 24px);
      }

      @media (max-width: 767px) {
        display: flex;
        align-items: center;
      }

      .bottom {
        min-height: 35vh;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        justify-content: flex-start;
        @media (max-width: 767px) {
          min-height: 25vh;
        }
      }

      .multi_wrap {
        padding: 0 24px;
        width: 100%;
        max-width: 1000px;
        margin: 0 auto;

        @media (max-width: 767px) {
          padding: 0;
        }

        .fit_wrap {
          min-height: initial !important;
          margin: 0 !important;
          width: 100% !important;
          // padding: 0 !important;
          max-width: initial !important;
        }

        &.center {
          min-height: calc(35vh - 24px);
          display: flex;
          justify-content: center;
          align-items: center;
          align-content: center;
          flex-wrap: wrap;

          @media (max-width: 767px) {
            min-height: 25vh;
            justify-content: flex-start;
            align-items: flex-end;
            align-content: flex-end;
          }

          h1 {
            margin-top: 0 !important;
          }
        }

        &.padding {
          @media (max-width: 767px) {
            padding: 5px 20px 0;
          }
        }
      }

      .fit_wrap {
        max-width: 800px;
        margin: 0 auto;
        padding: 0 40px;
        min-height: calc(35vh - 24px);
        display: flex;
        width: 100%;

        justify-content: flex-start;
        align-items: center;
        align-content: center;
        flex-wrap: wrap;

        @media (max-width: 767px) {
          padding: 0 !important;
          display: block !important;
          min-height: initial !important;
          margin: 0 !important;
          min-height: calc(25vh - 24px);
          &.padding {
            padding: 5px 24px 0 !important;
          }
        }

        &.center {
          justify-content: center;
        }
      }

      .full_left {
        padding: 0;
        width: 100%;
        max-width: 1000px;
        margin: 0 auto;
        min-height: 35vh;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        align-content: center;
        flex-wrap: wrap;

        h1 {
          margin-top: 0 !important;
        }

        @media (max-width: 767px) {
          align-items: flex-end;
          align-content: flex-end;
          min-height: 25vh;
        }
      }

      h1 {
        font-size: 36px;
        // font-weight: bold;
        line-height: 1;
        text-align: left;
        color: white;
        background: #25adf4;
        padding: 2px 0;
        margin: 12px;
        line-height: 1.4;
        display: inline;
        box-shadow: 12px 0 0 #25adf4, -12px 0 0 #25adf4;
        text-transform: uppercase;
        box-decoration-break: clone;
        @media (max-width: 767px) {
          text-align: left;
          font-size: 30px;
          margin: 0 0 10px;
          line-height: 1.8;
          padding: 7px 0;
        }

        &.no_bg {
          @media (min-width: 768px) {
            background: none;
            box-shadow: none;
            width: 100%;
            display: block;
          }
          @media (max-width: 767px) {
            margin: 0;
          }
        }
        &.smaller {
          font-size: 36px;
          margin: 12px 0 50px;
        }
      }
      .contain {
        padding: 0 60px;
        width: 100%;
        @media (max-width: 767px) {
          padding: 10px 50px;
          background: #25adf4;
          margin-top: 5px;

          &.noQuote {
            padding: 10px 14px;
          }
        }

        &.block {
          background: #25adf4;
          width: 100%;
          text-align: center;
          padding: 10px 0;

          @media (max-width: 767px) {
            padding: 20px 50px;
          }

          h2 {
            display: block;
            max-width: 600px;
            width: 100%;
            margin: 0 auto;
            font-size: 24px;
            line-height: 1.4;

            &:before {
              font-size: 70px;
              line-height: 1;
              padding-right: 8px;
            }
            &:after {
              font-size: 70px;
              line-height: 1;
              padding-left: 0;
            }
            @media (max-width: 767px) {
              font-size: 20px;

              &:before {
                font-size: 60px;
                line-height: 1;
                padding-right: 8px;
              }
              &:after {
                font-size: 60px;
                line-height: 0.9;
                padding-left: 8px;
              }
            }
          }
        }
      }
      h2 {
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.35;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
        margin-bottom: 0px;
        color: white;
        background: #25adf4;
        padding: 10px 12px;
        max-width: 750px;
        display: inline-block;
        box-decoration-break: clone;
        @media (max-width: 767px) {
          text-align: left;
          font-size: 18px;
          line-height: 25px;
          letter-spacing: 0;
          padding: 12px;
          margin: 0 -12px -12px;
          width: calc(100% + 24px);
        }
        &.sign_subtitle {
          background: #25adf4;
          display: inline;
          position: relative;
          display: inline;
          position: relative;
          line-height: 1.7;
          padding: 5px 0;
          font-size: 30px;
          box-shadow: 12px 0 0 #25adf4, -12px 0 0 #25adf4;
          @media (max-width: 767px) {
            margin: 0;
            font-size: 20px;
            line-height: 1.3;
            padding: 0;
            background: none;
          }
        }
        &.quote {
          &:before {
            content: "\201C";
            position: absolute;
            right: 100%;
            font-size: 70px;
            line-height: 0.8;
            padding-right: 14px;
          }
          &:after {
            content: "\201D";
            position: absolute;
            left: 100%;
            font-size: 70px;
            line-height: 0.8;
            padding-left: 14px;
          }

          @media (max-width: 767px) {
            &:before {
              font-size: 60px;
              line-height: 1;
              padding-right: 8px;
            }
            &:after {
              font-size: 60px;
              line-height: 0.9;
              padding-left: 8px;
            }
          }
        }
      }
    }
  }

  &.smaller {
    .slide_image {
      min-height: 25vh;
      .slide_title {
        min-height: calc(25vh - 24px);
        .fit_wrap {
          min-height: calc(25vh - 24px);
        }
      }
    }
  }

  .one_col_inner {
    width: 100%;
    max-width: 1225px;
    padding: 40px 12px;
    background: white;

    @media (max-width: 767px) {
      border-radius: 0 !important;
      padding: 12px;
    }

    &.shadow {
      box-shadow: 0 2px 8px 2px rgba(0, 0, 0, 0.11);
      @media (max-width: 767px) {
        box-shadow: none;
      }
    }

    &.center {
      text-align: center;
      @media (max-width: 767px) {
        text-align: left;
      }
    }
  }
}
</style>
